/* eslint-disable */
export const validationMobile = (value) => {
  if (!value.match(/^09\d{9}$/g)) {
    return false
  } else {
    return true
  }
}
export const validationPhone = (value) => {
  if (!value.match(/[0-9]{8}/g)) {
    return false
  } else {
    return true
  }
}

export const validationEmail = (value) => {
  if (
    !value.match(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g
    )
  ) {
    return false
  } else {
    return true
  }
}

export const validationHour = (value) => {
  if (!value.match(/^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$/g)) {
    return false
  } else {
    return true
  }
}

export const validationEconomicCode = (value) => {
  if (!value.match(/[0-9]{10,}/g)) {
    return false
  } else {
    return true
  }
}

export const validationRegistrationNumber = (value) => {
  if (!value.match(/[0-9]{6,}/g)) {
    return false
  } else {
    return true
  }
}

export const validationFax = (value) => {
  if (!value.match(/[0][1-9]{2}[0-9]{8}/g)) {
    return false
  } else {
    return true
  }
}

export const validationNationalId = (value) => {
  var sum = 0
  for (var i = 0; i < value.length - 1; i++) {
    sum += value.charAt(i) * (i + 1)
  }
  sum += 1
  var val = sum % 11
  val = Math.abs(val - 1)

  if (!(value.charAt(value.length - 1) == val)) {
    return false
  } else if (
    value == '0000000000' ||
    value == '1111111111' ||
    value == '2222222222' ||
    value == '3333333333' ||
    value == '4444444444' ||
    value == '5555555555' ||
    value == '6666666666' ||
    value == '7777777777' ||
    value == '8888888888' ||
    value == '9999999999'
  ) {
    return false
  } else {
    return true
  }
}
